import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const loadMaximumMaterialDiscountByGroup = (
  data: any
): Promise<{ data: any; total: number }> => {
  return axios.get('/parameters/discount-max-mat-group', data)
}

export function useLoadMaximumMaterialDiscountByGroup(query: any) {
  return useQuery(
    ['maximumMaterialDiscountByGroup', query],
    () => loadMaximumMaterialDiscountByGroup(query),
    {
      onError: () =>
        toast.error('Não foi possível carregar as alçadas de desconto!', {
          toastId: 'loadMaximumMaterialDiscountByGroup'
        })
    }
  )
}
